import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class Returns {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <section class="fg-card">
                <div class="fg-prose">
                    <p style="margin-bottom: 1.5rem;">At <strong>footballgirl</strong>, we want you to be completely satisfied with your purchase. Because our products are printed on demand via our partner Printify, our returns process is handled on a case-by-case basis to ensure the best possible resolution for our community.</p>
                    
                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">Reporting Issues</h3>
                    <p style="text-align: left; margin-bottom: 1.5rem;">Customers have <strong>30 days</strong> from the date of delivery to report any issues with their order, including defects, printing errors, or items damaged in shipping.</p>

                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">Damaged or Faulty Items</h3>
                    <p style="text-align: left; margin-bottom: 1.5rem;">If your item arrives damaged during transit or has a clear manufacturing defect, we will provide a <strong>free replacement</strong>. Please contact our support team with a photo of the damage and your order number.</p>

                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">Print-on-Demand & Customisation</h3>
                    <p style="text-align: left; margin-bottom: 1.5rem;">Because each item is customised and printed specifically for you, <strong>we cannot accept returns or exchanges for change of mind or incorrect size selection</strong>. We encourage you to check our Size Guide carefully before placing an order.</p>

                    <h3 class="fg-section-title" style="text-align: left; margin-top: 2rem; margin-bottom: 1rem;">How to Start a Return</h3>
                    <p style="text-align: left;">To report an issue and initiate a case-by-case review, please email our support team at <a href="mailto:support@footballgirl.eu" style="color: var(--primary-blue); font-weight: 600;">support@footballgirl.eu</a> with your order reference. We work closely with Printify to resolve all valid claims as quickly as possible.</p>
                </div>
            </section>
        `;

        el.innerHTML = sidebarPage({
            title: 'Returns & Refunds',
            subtitle: 'Our policy on order issues, damaged goods, and replacements',
            main,
            wide: false
        });
        
        // Smooth scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}